var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartLineUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2007_1680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 5.00195V8.75195H23.5988L18.1251 14.2257L13.1251 9.2257L6.17383 16.177L8.82508 18.8282L13.1238 14.5295L18.1238 19.5295L26.2488 11.4045V15.0032H29.9988V5.00195H20.0001Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.375 26.25H30V30H4.375C1.9625 30 0 28.0375 0 25.625V0H3.75V25.625C3.75 25.97 4.03 26.25 4.375 26.25Z",
    fill: "#EAEAEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2007_1680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLineUp);
export default __webpack_public_path__ + "static/media/chart-line-up.2436899f820f50beb89876f56458e7ce.svg";
export { ForwardRef as ReactComponent };